/*
 * Interface strings, Vietnamese.
 *
 * The "ui" bucket: everything outside the calculators. Every language the
 * picker offers has a full file here, so no English leaks into a translated
 * interface. Calculator text lives in i18n/calc, which is English and Spanish
 * only. Legal and disclaimer text is in neither: it stays English everywhere,
 * with legal.englishGoverning beside it.
 *
 * Plural keys end _one/_other and are chosen by Intl.PluralRules for this
 * language; Chinese, Thai, Vietnamese and Indonesian have one form, so they
 * carry only _other and every count lands there.
 */

/* NOT REVIEWED BY A NATIVE SPEAKER. */

const strings = {
  "landing.lead": "Đăng nhập bằng tài khoản AquaNetica của bạn để tiếp tục.",
  "landing.signIn": "Đăng nhập",
  "landing.signUpFree": "Đăng ký miễn phí.",
  "common.close": "Đóng",
  "common.cancel": "Hủy",
  "profile.title": "Hồ sơ hệ thống · {name}",
  "profile.subtitle": "Gia dùng thông tin này để điều chỉnh mọi câu trả lời trong dự án. Để trống những mục không liên quan.",
  "profile.species": "Loài nuôi",
  "profile.speciesPlaceholder": "ví dụ: cá hồi Đại Tây Dương",
  "profile.systemType": "Loại hệ thống",
  "profile.select": "Chọn…",
  "profile.sys.ras": "RAS (tuần hoàn)",
  "profile.sys.flow": "Nước chảy một chiều",
  "profile.sys.pond": "Ao",
  "profile.sys.cage": "Lồng bè",
  "profile.sys.hatchery": "Trại giống",
  "profile.sys.other": "Khác",
  "profile.volume": "Tổng thể tích (L)",
  "profile.temp": "Nhiệt độ mục tiêu (°C)",
  "profile.lifeStage": "Giai đoạn nuôi",
  "profile.lifeStagePlaceholder": "cá giống, cá lỡ, cá bố mẹ",
  "profile.location": "Địa điểm",
  "profile.locationPlaceholder": "ví dụ: Cần Thơ, VN",
  "profile.notes": "Ghi chú thêm",
  "profile.notesPlaceholder": "Bất kỳ điều gì khác Gia nên biết về hệ thống này",
  "profile.save": "Lưu hồ sơ",
  "help.title": "Giới thiệu và tuyên bố miễn trừ",
  "help.about": "Gia là trợ lý AI cho người vận hành trại nuôi thủy sản, có sẵn các công cụ tính toán kỹ thuật. Gia trả lời dựa trên tài liệu tham khảo và kiến thức chung để giúp bạn suy nghĩ về hệ thống, chất lượng nước và thiết bị.",
  "legal.englishGoverning": "Điều khoản và tuyên bố miễn trừ được cung cấp bằng tiếng Anh. Bản tiếng Anh là bản có hiệu lực.",
  "feature.notNow": "Để sau",
  "feature.seePlans": "Xem các gói",
  "lang.title": "Ngôn ngữ",
  "lang.sub": "Đặt ngôn ngữ giao diện và ngôn ngữ Gia trả lời, dù bạn gõ bằng ngôn ngữ nào.",
  "lang.auto": "Tự động (theo trình duyệt và câu hỏi của tôi)",
  "pe.timeline.ASAP": "Càng sớm càng tốt",
  "pe.timeline.1–3 months": "1–3 tháng",
  "pe.timeline.Just researching": "Chỉ đang tìm hiểu",
  "pe.condition.New": "Mới",
  "pe.condition.Used": "Đã qua sử dụng",
  "pe.condition.Either": "Loại nào cũng được",
  "pe.missing.quantity": "bạn cần bao nhiêu",
  "pe.missing.city": "giao đến đâu",
  "pe.missing.date": "khi nào bạn cần",
  "pe.nudge": "Nhà cung cấp thường không báo giá được nếu chưa biết {list}. Bạn vẫn có thể gửi.",
  "pe.err.name": "Vui lòng nhập tên của bạn để chúng tôi biết trả lời cho ai.",
  "pe.err.email": "Vui lòng nhập email để chúng tôi có thể trả lời.",
  "pe.err.emailInvalid": "Email này có vẻ chưa đúng, vui lòng kiểm tra lại.",
  "pe.err.quantity": "Vui lòng cho biết bạn cần bao nhiêu.",
  "pe.err.city": "Vui lòng cho biết thành phố nhận hàng.",
  "pe.err.send": "Không gửi được yêu cầu của bạn. Vui lòng thử lại.",
  "pe.err.network": "Không kết nối được với máy chủ. Vui lòng kiểm tra kết nối và thử lại.",
  "pe.title": "Giúp tôi tìm mua thiết bị này",
  "pe.thanks": "Cảm ơn bạn. Chúng tôi sẽ liên hệ qua {email}.",
  "pe.done": "Xong",
  "pe.whatYouNeed": "Thứ bạn cần",
  "pe.equipment": "Thiết bị",
  "pe.suggestedModels": "Model gợi ý:",
  "pe.hideDetails": "Ẩn chi tiết",
  "pe.editDetails": "Sửa chi tiết",
  "pe.item": "Thiết bị bạn cần",
  "pe.specs": "Chi tiết và công suất",
  "pe.name": "Tên của bạn",
  "pe.email": "Email (để chúng tôi trả lời)",
  "pe.when": "Khi nào bạn cần?",
  "pe.quantity": "Bạn cần bao nhiêu cái?",
  "pe.quantityPlaceholder": "ví dụ: 2 cái",
  "pe.city": "Thành phố nhận hàng",
  "pe.cityPlaceholder": "Giao hàng đến đâu?",
  "pe.neededBy": "Cần trước ngày (không bắt buộc)",
  "pe.condition": "Mới hay đã qua sử dụng? (không bắt buộc)",
  "pe.budget": "Ngân sách dự kiến (không bắt buộc)",
  "pe.amount": "Số tiền",
  "pe.budgetAmount": "Số tiền ngân sách",
  "pe.budgetCurrency": "Loại tiền",
  "pe.notSure": "Chưa rõ",
  "pe.note": "Còn điều gì khác không? (không bắt buộc)",
  "pe.notePlaceholder": "Bất kỳ thông tin nào giúp chúng tôi tìm đúng thứ bạn cần.",
  "pe.hideFarm": "Ẩn thông tin trại nuôi",
  "pe.addFarm": "Thêm thông tin trại nuôi (không bắt buộc)",
  "pe.farm": "Tên trại nuôi hoặc công ty",
  "pe.country": "Quốc gia",
  "pe.sending": "Đang gửi…",
  "pe.send": "Gửi yêu cầu",
  "pe.reassurance": "Không ràng buộc. Một người của AquaNetica sẽ trả lời qua email.",
  "toolbar.answerLanguage": "Ngôn ngữ: {name}",
  "toolbar.answerLanguageTitle": "Ngôn ngữ",
  "project.namePrompt": "Tên dự án?",
  "project.renamePrompt": "Đổi tên dự án:",
  "project.deleteWithChats": "Xóa dự án \"{name}\" và {count} cuộc trò chuyện của nó?",
  "project.deleteWithChats_other": "Xóa dự án \"{name}\" và {count} cuộc trò chuyện của nó?",
  "project.delete": "Xóa dự án \"{name}\"?",
  "file.proTitle": "Tin nhắn kèm tệp là tính năng Pro",
  "file.proMessage": "Gói của bạn không có tin nhắn kèm tệp. Nâng cấp lên Pro để đính kèm thông số kỹ thuật, bản vẽ và ảnh cho Gia đọc. Tin nhắn kèm tệp là bất kỳ tin nhắn nào bạn gửi khi đang đính kèm tệp.",
  "file.badType": "Vui lòng đính kèm ảnh (JPG, PNG, GIF, WEBP), tệp PDF, tệp Word, Excel, PowerPoint (.docx, .xlsx, .pptx) hoặc tệp văn bản hay mã (.txt, .md, .csv, .json, .r, .py).",
  "file.tooLarge": "Tệp quá lớn. Vui lòng giữ tệp đính kèm dưới 20 MB.",
  "file.unreadable": "Gia không đọc được tệp này. Nếu tệp có mật khẩu hoặc là tệp .doc, .xls, .ppt cũ, hãy lưu lại thành .docx, .xlsx hoặc .pptx không có mật khẩu rồi đính kèm lại.",
  "file.noText": "Tệp này không có văn bản nào Gia đọc được. Nếu đó là bản quét hoặc chủ yếu là hình ảnh, hãy đính kèm dưới dạng PDF hoặc ảnh.",
  "file.tooBig": "Tệp này quá lớn để Gia đọc một lần. Hãy chia thành các tệp nhỏ hơn hoặc chỉ đính kèm phần bạn cần.",
  "file.notText": "Tệp này không phải văn bản thuần, dù tên tệp cho thấy như vậy. Hãy lưu lại dưới dạng văn bản (UTF-8) rồi đính kèm lại.",
  "chat.errSomething": "Xin lỗi, đã có lỗi xảy ra: {detail}",
  "chat.errNoBackend": "Xin lỗi, tôi không kết nối được với kho tài liệu. Hãy kiểm tra backend có đang chạy ở cổng 3001 không.",
  "file.attached": "· đã đính kèm vào cuộc trò chuyện này",
  "file.left": "Còn {count} tin nhắn kèm tệp trong tháng này",
  "file.left_other": "Còn {count} tin nhắn kèm tệp trong tháng này",
  "file.detachTitle": "Bỏ tệp đính kèm: tệp sẽ không còn tính vào hạn mức tin nhắn kèm tệp",
  "file.detachLabel": "Bỏ tệp đính kèm",
  "file.detach": "Bỏ tệp",
  "file.explain": "Mỗi tin nhắn bạn gửi khi tệp này còn đính kèm sẽ tính là một tin nhắn kèm tệp. Hãy bỏ đính kèm khi Gia không cần tham khảo tệp nữa.",
  "file.reattachHint": "{name}: đính kèm lại để tiếp tục hỏi về tệp này",
  "file.reattachTitle": "Đính kèm lại tệp",
  "file.reattach": "Đính kèm lại",
  "usage.questions": "Còn {left} trong {limit} câu hỏi của tháng này",
  "usage.questions_other": "Còn {left} trong {limit} câu hỏi của tháng này",
  "usage.questionsShort": "Còn {left}/{limit} câu hỏi",
  "usage.questionsShort_other": "Còn {left}/{limit} câu hỏi",
  "usage.files": "Còn {left} trong {limit} tin nhắn kèm tệp",
  "usage.files_other": "Còn {left} trong {limit} tin nhắn kèm tệp",
  "usage.leftShort": "Còn {left} câu hỏi",
  "usage.leftShort_other": "Còn {left} câu hỏi",
  "usage.remaining": "Còn {left} / {limit} câu hỏi",
  "usage.remaining_other": "Còn {left} / {limit} câu hỏi",
  "usage.upgrade": "Nâng cấp",
  "wall.daily": "Bạn đã dùng hết số tin nhắn của hôm nay",
  "wall.feature": "Gói {plan} không có tính năng này",
  "wall.featureYour": "Gói của bạn không có tính năng này",
  "wall.files": "Bạn đã dùng hết {limit} tin nhắn kèm tệp của gói {plan} trong tháng này",
  "wall.questions": "Bạn đã dùng hết {limit} câu hỏi của gói {plan} trong tháng này",
  "wall.generic": "Bạn đã chạm giới hạn của gói",
  "wall.region": "Đã hết số câu hỏi",
  "wall.refresh": "Số câu hỏi của gói {plan} được làm mới vào ngày 1 hằng tháng.",
  "wall.refreshNoPlan": "Số câu hỏi của bạn được làm mới vào ngày 1 hằng tháng.",
  "wall.stayFree": "Các công cụ tính toán vẫn miễn phí và không giới hạn, và mọi cuộc trò chuyện trước đây vẫn còn ở đây để bạn đọc lại.",
  "wall.upgrade": "Nâng cấp tại aquanetica.com",
  "sidebar.hide": "Ẩn thanh bên",
  "sidebar.search": "Tìm cuộc trò chuyện…",
  "sidebar.newChat": "+ Trò chuyện mới",
  "sidebar.newProject": "+ Dự án",
  "sidebar.tools": "🛠️ Công cụ",
  "sidebar.backToGia": "Quay lại Gia",
  "sidebar.calculator": "Công cụ tính",
  "sidebar.empty": "Chưa có cuộc trò chuyện nào. Hãy hỏi Gia bất cứ điều gì để bắt đầu.",
  "sidebar.profileSet": "Đã có hồ sơ hệ thống",
  "sidebar.newInProject": "Trò chuyện mới trong dự án này",
  "sidebar.editProfile": "Sửa hồ sơ",
  "sidebar.rename": "Đổi tên",
  "sidebar.delete": "Xóa",
  "sidebar.projectEmpty": "Chưa có cuộc trò chuyện nào",
  "sidebar.noMatches": "Không có kết quả cho \"{q}\"",
  "sidebar.signedIn": "Đã đăng nhập",
  "sidebar.signOut": "Đăng xuất",
  "sidebar.signingOut": "Đang đăng xuất…",
  "signout.title": "Đăng xuất",
  "signout.body": "Bạn sẽ đăng xuất khỏi AquaNetica IQ và aquanetica.com. Tài liệu đã tải lên và đánh giá câu trả lời luôn được xóa khỏi thiết bị này. Mọi thứ khác bạn đã lưu vẫn ở đây cho lần đăng nhập sau.",
  "signout.alsoClear": "Xóa luôn công việc đã lưu trên thiết bị này: cuộc trò chuyện, dự án và phép tính",
  "signout.irreversible": "Việc xóa thêm này là vĩnh viễn. Phần đó chỉ được lưu trong trình duyệt này, không có bản sao để khôi phục.",
  "signout.confirm": "Đăng xuất",
  "sidebar.communityTitle": "Quay lại cộng đồng AquaNetica (mở trong tab mới)",
  "sidebar.community": "Quay lại AquaNetica",
  "sidebar.help": "Trợ giúp và tuyên bố miễn trừ",
  "drop.label": "Thả tệp vào đây để đính kèm",
  "toolbar.showSidebar": "Hiện thanh bên",
  "toolbar.toggleSidebar": "Ẩn hoặc hiện thanh bên",
  "toolbar.newChat": "Trò chuyện mới",
  "toolbar.inProject": "Trong dự án:",
  "toolbar.home": "Quay lại cộng đồng AquaNetica",
  "toolbar.homeTitle": "Quay lại AquaNetica (mở trong tab mới)",
  "toolbar.calc": "Mở công cụ tính",
  "toolbar.theme": "Đổi giao diện sáng/tối",
  "hero.title": "Tôi có thể giúp gì cho bạn?",
  "hero.calibrated": "Gia đã được điều chỉnh theo hồ sơ hệ thống của dự án này.",
  "hero.noProfile": "Chưa có hồ sơ hệ thống. Bấm ⚙ trên dự án để tạo.",
  "hero.subtitle": "Hỏi bất cứ điều gì về hệ thống nuôi thủy sản, chất lượng nước hoặc thiết bị.",
  "composer.attachTitle": "Đính kèm ảnh hoặc PDF",
  "composer.attachLabel": "Đính kèm tệp",
  "composer.send": "Gửi",
  "answer.copyTitle": "Sao chép câu trả lời",
  "answer.copied": "Đã sao chép",
  "answer.copy": "Sao chép",
  "answer.retryTitle": "Hỏi lại câu này",
  "answer.retryLabel": "Trả lời lại",
  "answer.retry": "Thử lại",
  "answer.good": "Câu trả lời tốt",
  "answer.bad": "Câu trả lời chưa tốt",
  "answer.sourcing": "Cần giúp tìm mua thiết bị này? →",
  "answer.searching": "Đang tìm trong thư viện tài liệu…",
  "answer.scrollLatest": "Đến tin mới nhất",
  "sidebar.otherChats": "Khác",
  "trial.have": "Bạn có mã dùng thử?",
  "trial.title": "Mã dùng thử",
  "trial.placeholder": "Nhập mã dùng thử của bạn",
  "trial.submit": "Kích hoạt",
  "trial.checking": "Đang kiểm tra…",
  "trial.invalid": "Mã này không hợp lệ. Vui lòng kiểm tra lại.",
  "trial.error": "Không kiểm tra được mã này. Vui lòng thử lại.",
  "trial.success": "Đã bật bản dùng thử Pro. Bạn có 75 câu hỏi và 10 tin nhắn kèm tệp mỗi tháng cho đến {date}.",
  "trial.active": "Dùng thử Pro đến {date}",
  "sidebar.planTrial": "Dùng thử {plan}",
  "sidebar.managePlan": "Quản lý gói",
  "trial.ends": "Bản dùng thử kết thúc ngày {date}",
  "pe.consent": "Tôi đồng ý chia sẻ thông tin yêu cầu của tôi với AquaNetica và với các nhà cung cấp được liên hệ thay mặt tôi, và đồng ý với {terms} và {privacy}.",
  "pe.consentTerms": "Điều khoản dịch vụ",
  "pe.consentPrivacy": "Chính sách bảo mật",
};

export default strings;
